import clsx from 'clsx';
import React from 'react';

interface ISkeletonLoaderProps {
  className?: string;
  width?: string | number;
  height?: string | number;
  variant?: 'text' | 'rect' | 'circle';
}

const SkeletonLoader: React.FC<ISkeletonLoaderProps> = ({
  className,
  width,
  height,
  variant = 'rect',
}) => {
  const baseStyles = 'animate-pulse bg-neutral-100 dark:bg-neutral-200';

  const variantStyles = {
    text: 'rounded',
    rect: 'rounded-md',
    circle: 'rounded-full',
  };

  const style = {
    width: width,
    height: height,
  };

  return (
    <div
      className={clsx(baseStyles, variantStyles[variant], className)}
      style={style}
      role="status"
      aria-label="Loading..."
    />
  );
};

export default SkeletonLoader;
